import React from 'react';
import { Box, Typography, Card, Alert, Button, LinearProgress } from '@mui/joy';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { subcontractorsApi } from '../../lib/apiSubcontractors';
import { SubcontractorForm } from '../../components/subcontractors';

export const SubcontractorEditPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const { data: subcontractor, isLoading, error, refetch } = useQuery({
    queryKey: ['subcontractor', id],
    queryFn: () => subcontractorsApi.get(Number(id)),
    enabled: !!id,
  });

  if (isLoading) return <LinearProgress />;
  if (error || !subcontractor) return <Alert color="danger">Unable to load this subcontractor. <Button onClick={() => refetch()}>Retry</Button></Alert>;

  return (
    <Box sx={{ p: 3, maxWidth: '1200px', mx: 'auto' }}>
      <Typography level="h2" sx={{ mb: 3 }}>
        Edit Subcontractor
      </Typography>
      <Card>
        <SubcontractorForm 
          editId={Number(id)}
          subcontractor={subcontractor}
          onSuccess={(subcontractor) => {
            navigate(`/operations/subcontractors/${subcontractor.id}`);
          }}
          onCancel={() => navigate(`/operations/subcontractors/${id}`)}
        />
      </Card>
    </Box>
  );
};